import React from 'react';
import { userIsLogin, userLogin, isGrounds } from '@src/public/utils/app';
import { customModal } from '@src/mobile/components/ModalBox';
import Input from './Input';

export const showInput = ({ replyName, callback }) => {
    const maxSize = 200;
    const config = {
        placeholder: replyName ? `回复${replyName}` : '请输入友善的评论',
        maxSize,
        limit: maxSize,
        additional: ['emoji'],
    };

    if (userIsLogin()) {
        if (isGrounds && (window.grounds.openInput || window.grounds.input)) {
            const groundsCallbackName = 'inputFromClient';

            window[groundsCallbackName] = data => {
                const text = JSON.parse(data.replace(/\n/g, '\\n').replace(/\r/g, '\\r'))?.text?.trim();

                if (text && callback) {
                    callback(text);
                }
            };

            if (window.grounds.openInput) {
                window.grounds.openInput(JSON.stringify(config), groundsCallbackName);
            } else {
                window.grounds.input(JSON.stringify(config), groundsCallbackName);
            }
        } else {
            customModal(Input, { callback, config });
        }
    } else {
        userLogin();
    }
};
